export const getTaxStatus = (tax) => {
  const taxLabel = tax?.toLowerCase();
  if (
    taxLabel === "a" ||
    taxLabel === "b" ||
    taxLabel === "c" ||
    taxLabel === "d" ||
    taxLabel === "f" ||
    taxLabel === "g" ||
    taxLabel === "i" ||
    taxLabel === "j" ||
    taxLabel === "k" ||
    taxLabel === "l" ||
    taxLabel === "m" ||
    taxLabel === "o" ||
    taxLabel === "p" ||
    taxLabel === "s" ||
    taxLabel === "t" ||
    taxLabel === "u" ||
    taxLabel === "y" ||
    taxLabel === "z"
  ) {
    return "Qualified";
  } else if (
    taxLabel === "e" ||
    taxLabel === "q" ||
    taxLabel === "r" ||
    taxLabel === "x"
  ) {
    return "Non-Qualified";
  } else {
    return "";
  }
};
